import {BrandType, Brands} from '../types'

export const brands: Brands = {
  etrip: {
    code: 'etrip',
    name: 'Etrip',
    defaultDomain: 'etrip.net'
  },
  findhotel: {
    code: 'findhotel',
    name: 'FindHotel',
    defaultDomain: 'findhotel.net'
  },
  vio: {
    code: 'vio',
    name: 'Vio',
    defaultDomain: 'vio.deals'
  }
}

export const defaultBrand: BrandType = brands.findhotel
